import { render, staticRenderFns } from "./TheSessionHistoryMobile.vue?vue&type=template&id=5884f86c&scoped=true"
import script from "./TheSessionHistoryMobile.vue?vue&type=script&lang=js"
export * from "./TheSessionHistoryMobile.vue?vue&type=script&lang=js"
import style0 from "./TheSessionHistoryMobile.vue?vue&type=style&index=0&id=5884f86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884f86c",
  null
  
)

export default component.exports